









































































































































































































































































































import {Vue, Component, Watch, Ref, Prop} from 'vue-property-decorator'
import {Getter, Action, Mutation} from "vuex-class";
import {DateTime} from "luxon";
import {cloneDeep, isEqualWith, omit} from "lodash";
import {CollapseTransition} from "vue2-transitions";
import {
  FormRowWings,
  SelectWings,
  DatePickerWings,
  ToggleWings,
  Collapse,
  SpoilerWings,
  TimeoutWings,
  FieldTooltip,
  SmsTextInputWings,
  InputWings
} from 'wings-ui-components';
import {notifyConfirm, notifyDelete, notifyError} from "@/utils/notify-helper";
import {TemplateItem} from '@/store/templates/types';
import {MsgTransports} from '@/store/types';
import { transformTransport } from '@/utils/download-helper';
import { ActionLog } from '@/store/auth/types';
import { getTranslatedParams } from '@/utils/notify-utils';
import MaskingTemplate from "@/components/Templates/MaskingTemplate.vue";
import CloneTemplateDialog from "@/components/Templates/CloneTemplateDialog.vue";
import BlackListSelection from "@/components/Templates/BlackListSelection.vue";
import AdditionalParamsCard from "@/components/Templates/AdditionalParamsCard.vue";

@Component({
  components: {
    FieldTooltip,
    FormRowWings,
    SelectWings,
    DatePickerWings,
    ToggleWings,
    Collapse,
    SpoilerWings,
    SmsTextInputWings,
    CollapseTransition,
    TimeoutWings,
    MaskingTemplate,
    CloneTemplateDialog,
    BlackListSelection,
    InputWings,
    AdditionalParamsCard
  },
  methods: {transformTransport}
})
export default class GenericTemplate extends Vue {
  @Ref('validator') validator: any;
  @Prop() transport!: MsgTransports;
  @Prop() distribution!: any;

  @Getter("partners") partnersList: any;
  @Getter("partnerUsers") partnerUsersList: any;
  @Getter("originators") originatorsList: any;
  @Getter("priorityList") priorityList: any;
  @Getter("messageTypes") messageTypesList: any;

  @Getter("transportsMultichannel") transportsMultichannelList: any;
  @Getter("multichannelTemplates") smsMultichannelTemplatesList: any;
  @Getter("moderationSettings") moderationSettings: any;

  @Action("getTemplateItem") actionGetTemplateItem: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPartnerUsers") actionGetPartnersUsers: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("getBlacklists") actionGetBlackLists: any;
  @Action("getTransports") actionGetTransports: any;
  @Action("getTransportsMultichannel") actionGetTransportsMultichannel: any;
  @Action("getMultichannelTemplates") actionGetMultichannelTemplates: any;
  @Action("saveTemplate") actionSaveTemplate: any;
  @Action("deleteTemplate") actionDeleteTemplate: any;
  @Action("createDraft") actionCreateDraft: any;
  @Action("sendToModeration") actionSendToModeration: any;
  @Action("replaceDraft") actionReplaceDraft: any;
  @Action("actionLog") actionLog: any;

  @Getter("templateObject") template: any;
  @Mutation('setTemplateObject') setTemplateObject: any

  private emailTransport: MsgTransports = MsgTransports.EMAIL;
  private pushTransport: MsgTransports = MsgTransports.PUSH;
  private mnTransport: MsgTransports = MsgTransports.MAILNOTIFY;
  private telegramOtpTransport: MsgTransports = MsgTransports.TELEGRAM_OTP;

  private templateSaved: any
  private weekDays = [
    {value: 'MON'},
    {value: 'TUE'},
    {value: 'WED'},
    {value: 'THU'},
    {value: 'FRI'},
    {value: 'SAT'},
    {value: 'SUN'}
  ];
  private is_cascading = false;
  private isEditable = true
  private isShowCloneTemplate = false
  private cloneTemplateError: any = null
  logObject: ActionLog = {}

  get moderation() {
    return this.moderationSettings.find((item: any) => item.transportName == this.transport)?.status === 1
  }

  async createDraft() {
    try {
      const resp = await this.actionCreateDraft({templateId: this.template.templateId})
      if (resp?.data?.id) {
        this.$router.push(`/template/${transformTransport(this.transport)}/${resp.data.id}`)
      }
    } catch(error) {
      notifyError(error)
    }
  }

  async sendToModeration() {
    if (this.isTemplateChanged() && await notifyDelete(this.$t('dialog.confirm').toString())) {
      await this.onSaveItem(false);
    }
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Creation",
        actionStatus: 'success',
        objectType: this.template?.draftId ? "Draft template" : "Template",
        addititionalInfo: {
          "Статус / Status":"Ожидает модерации / For moderation",
          ID: this.template.templateId
        }
      }
      await this.actionSendToModeration({templateId: this.template.templateId})
      await this.actionLog(this.logObject)
      this.back()
    } catch(error) {
      notifyError(error)
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  async replaceDraft() {
    if (!await notifyDelete(this.$t('template.draft.replace').toString())) return
    try {
      await this.actionReplaceDraft({id: this.template.originalId, prev: this.template.templateId})
    } catch(error) {
      notifyError(error)
    }
  }

  created() {
    try {
      this.actionGetMessageTypes();
      this.actionGetTransportsMultichannel(this.transport);
      if (![this.pushTransport, this.mnTransport].includes(this.transport)) {
        this.actionGetOriginators({transport: this.transport.toString(), status: 'ACCEPTED'});
      }
      this.templateSaved = cloneDeep(this.template);
      // if (this.$route.params.id) this.getTemplate(this.$route.params.id)
    } catch(error) {
      notifyError(error)
    }
  }

  async getTemplate(templateId: string) {
    this.is_cascading = false
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Viewing",
        actionStatus: 'success',
        objectType: this.template?.draftId ? "Draft template" : "Template",
        objectName: this.template.name,
      }
      let data: TemplateItem = await this.actionGetTemplateItem({id: templateId, transport: this.transport})
      this.setTemplateObject(Object.assign(this.template, data))
      if (this.template.multichannelTemplateId || this.template.multichannelId) this.is_cascading = true
      this.$emit('onLoadTemplate', this.template)
      this.$nextTick(() => this.templateSaved = cloneDeep(this.template));
      this.isEditable = !!this.distribution || !this.moderation
                        || (this.moderation && ['ForEdit', 'Denied'].includes(this.template.status))
      if (!this.distribution) {
        this.logObject.objectName = this.template.name
        await this.actionLog(this.logObject)
      }
    } catch(error) {
      notifyError(error)
      if (!this.distribution) {
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    }
  }

  @Watch('$route.params.id', {immediate: true})
  onRouteIdChange(val: string, oldVal?: string) {
    if (val) {
      this.getTemplate(val)
    }
  }

  back():void{
    this.$router.push(`/template/${transformTransport(this.transport)}`);
  }

  async cloneTemplate(name: string) {
    try {
      let template = omit(this.template, ['templateId'])
      template = template.customData ? {...template, customData: JSON.parse(template.customData)} : template
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Creation",
        actionStatus: 'success',
        objectType: template?.draftId ? "Draft template" : "Template",
        addititionalInfo: getTranslatedParams(template, {
          distribution: 'distribution.distribution'
        })
      }
      const resp = await this.actionSaveTemplate({template: {...template, name}, transport: this.transport})
      await this.actionLog(this.logObject)
      this.isShowCloneTemplate = false
      this.$router.push(`/template/${transformTransport(this.transport)}/${resp.data.id}`);
    } catch (error) {
      // notifyError(error);
      this.cloneTemplateError = error;
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  onSaveItem(goBack = true): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      if (!await this.validator.validate()) {
        notifyError(null, this.validator.errors)
        reject()
        return
      }
      try {
        this.logObject = {
          actionPage: this.$route.meta.msgKey,
          action: this.$route.params.id ? "Editing" : "Creation",
          actionStatus: 'success',
          objectType: this.template?.draftId ? "Draft template" : "Template",
          addititionalInfo: getTranslatedParams(this.template, {
            distribution: 'distribution.distribution'
          })
        }
        const template = this.template.customData ? {...this.template, customData: JSON.parse(this.template.customData)} : this.template
        await this.actionSaveTemplate({template, transport: this.transport})
        await this.actionLog(this.logObject)
        this.templateSaved = cloneDeep(this.template);
        resolve()
        if (goBack) this.back();
      } catch (error) {
        reject()
        notifyError(error);
        await this.actionLog({...this.logObject, actionStatus: 'failed'})
      }
    })
  }

  async onDeleteItem(): Promise<void> {
    if (!await notifyDelete()) return
    try {
      this.logObject = {
        actionPage: this.$route.meta.msgKey,
        action: "Removal",
        actionStatus: 'success',
        objectType: this.template?.draftId ? "Draft template" : "Template",
        objectName: this.template.name,
        addititionalInfo: getTranslatedParams({id: this.template.templateId})
      }
      await this.actionDeleteTemplate({template: {templateId: this.template.templateId}, transport: this.transport})
      await this.actionLog(this.logObject)
      this.templateSaved = this.template;
      this.back();
    } catch (error) {
      notifyError(error);
      await this.actionLog({...this.logObject, actionStatus: 'failed'})
    }
  }

  get minEndingDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.startingDate) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.startingDate)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.startingDate
  }

  get minEndDatetime(): string {
    let now = DateTime.local().set({millisecond: 0})
    if (!this.template.startDatetime) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';
    if (now > DateTime.fromISO(this.template.startDatetime)) return now.toISO({
      includeOffset: false,
      suppressMilliseconds: true
    }) ?? '';

    return this.template.startDatetime
  }

  @Watch('template.startDatetime', {immediate: true})
  onChangeStartDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.distribution = false
    }
  }

  @Watch('template.endDatetime', {immediate: true})
  onChangeEndDateTime(val: string, oldVal?: string) {
    if (!val) {
      this.template.distribution = false
    }
  }

  @Watch('template.multichannelId', {immediate: true})
  async onTemplateChangeMultichannel(val: number, oldVal?: number) {
    if (val) {
      let transport = this.transportsMultichannelList.find((item: any) => item.id == val)?.name ?? '';
      if (transport) {
        try {
          await this.actionGetMultichannelTemplates({
            transport: transport.toLowerCase(),
            filter: {
              status: 'Active'
            }
          });
        } catch(error) {
          notifyError(error);
        }
      }
    }
    if (oldVal && val !== oldVal) {
      this.template.multichannelTemplateId = null;
    }
  }

  @Watch('is_cascading', {immediate: true})
  onChangeIsCascading(val?: boolean) {
    if (!val) {
      this.template.multichannelId = null;
      this.template.multichannelTemplateId = null;
      this.template.timeout = 0;
    }
  }

  onAllowedDaysChange() {
    this.template?.allowedDays?.sort()
    this.templateSaved?.allowedDays?.sort()
  }

  isTemplateChanged() {
    if (this.transport == this.emailTransport) {
      this.template.message = this.template.message.replace(/\n/ig, '')
      this.templateSaved.message = this.templateSaved.message.replace(/\n/ig, '')
    }
    const result = isEqualWith(this.templateSaved, this.template, function customizer(objValue:any, othValue:any) {
      if ((objValue === null && othValue === '') || (objValue === null && othValue === undefined)) return true
      return undefined
    })
    return !result
  }

  beforeLeave(to: any, from: any, next: any) {
    notifyConfirm(this.isTemplateChanged(), this.onSaveItem, next);
  }
}
